module.exports = __webpack_public_path__ + "static/media/WeatherNow.beaa9b66.png";